let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jiTjW")).then(() => parcelRequire('2xYLF'));